import query from './APIServices'

interface Countries {
  id: number
  name: string
  code: string
  flag: string
  priority: number
  prefix: string
}

export const getCountries = async (params?: { search?: string }) => {
  const cleanParams = params?.search ? { search: params.search } : undefined

  const response = await query.get('/invoice/public/countries', {
    params: cleanParams,
  })
  return response?.data.items as Countries[]
}
